import PropTypes from 'prop-types';
import Button from 'components/UI/Button';

const MissingOnboardingScreen = ({
  literals,
  onCompleteIdentification,
  onBack,
}) => (
  <div className='full-screen-container digital-loan-result-screen digital-loan-missing-onboarding'>
    <div className='screen-content text-center'>
      <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
      <div className='digital-loan-missing-onboarding__hero' aria-hidden='true' />
      <p className='digital-loan-phase2__body'>{literals.body1}</p>
      <p className='digital-loan-phase2__body mb-4'>{literals.body2}</p>
    </div>
    <div className='screen-actions'>
      <Button text={literals.completeIdentification} onClick={onCompleteIdentification} />
      <Button text={literals.back} type='secondary' onClick={onBack} />
    </div>
  </div>
);

MissingOnboardingScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  onCompleteIdentification: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default MissingOnboardingScreen;
